/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Muscles_MetaInputs */

const en_us2_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this week`)
};

const pt_br2_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esta semana`)
};

const es_419_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esta semana`)
};

const pt_pt2_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esta semana`)
};

const fr_fr2_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cette semaine`)
};

const de_de2_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diese Woche`)
};

const it_it2_progress_muscles_meta = /** @type {(inputs: Progress_Muscles_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questa settimana`)
};

/**
* | output |
* | --- |
* | "this week" |
*
* @param {Progress_Muscles_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_muscles_meta = /** @type {((inputs?: Progress_Muscles_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Muscles_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_muscles_meta(inputs)
	if (locale === "es-419") return es_419_progress_muscles_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_muscles_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_muscles_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_muscles_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_muscles_meta(inputs)
	return en_us2_progress_muscles_meta(inputs)
});
export { progress_muscles_meta as "progress.muscles_meta" }